import WebRepository from '../web/WebRepository'
import Api from 'clients/web/Api'
import PatientsFilePage from 'model/PatientsFilePage'

export class PatientsFilesPagesRepository extends WebRepository<PatientsFilePage> {
  constructor() {
    super(new Api('patients_files'))
  }

  async searchPatientsFilePage(
    patientId: string,
    bookmark: string,
    filter: string | undefined,
    limit?: number,
  ): Promise<PatientsFilePage> {
    let selector = { patientId: patientId } as any
    if (filter && filter.length > 0 && filter !== 'all') {
      selector['category'] = filter
    }
    if (filter === undefined || filter === 'uncategorized') {
      selector['category'] = { $in: [null, 'uncategorized'] }
    }
    return super.searchPage({
      selector,
      limit: limit || 10,
      bookmark: bookmark,
      sort: { testDate: -1 },
    })
  }
}

export default new PatientsFilesPagesRepository()
